import { variablesGlobales } from '../../configs/variables';
import getInstanceAxios from '../axiosInstance';

export class PublicDocumentsService {

    static async getTratamientoDatos() {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/public-documents/tratamiento-datos`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error?.response?.data,
                date: new Date(),
                code: error.code,
                status: error?.response?.status || 500
            }
        }
    }

}
